import { X, Lock, CheckCircle2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

const PRO_FEATURES = [
  { label: 'Up to 10 certificate designs', note: '1 on Starter' },
  { label: 'Verification QR codes on certificates' },
  { label: 'Third-party certification' },
  { label: 'Custom expiry notification schedule' },
  { label: 'Advanced analytics dashboard' },
  { label: 'Embeddable session widget for your website' },
  { label: 'Course pages for your website, with pictures' },
]

export default function ProUpgradeDialog({
  open,
  onClose,
  featureName,
  onUpgrade,
}: {
  open: boolean
  onClose: () => void
  featureName: string
  onUpgrade?: () => void
}) {
  const navigate = useNavigate()

  if (!open) return null

  const handleUpgrade = () => {
    onClose()
    if (onUpgrade) {
      onUpgrade()
    } else {
      navigate('/admin/account?tab=billing')
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-sm p-6">
        <button type="button" onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer">
          <X size={18} />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center shrink-0">
            <Lock size={18} className="text-amber-500" />
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-amber-600 mb-0.5">Pro feature</p>
            <h2 className="text-base font-semibold text-gray-900 leading-tight">{featureName}</h2>
          </div>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          Upgrade to Pro to unlock this feature and more:
        </p>

        <ul className="space-y-2.5 mb-6">
          {PRO_FEATURES.map(f => (
            <li key={f.label} className="flex items-start gap-2 text-sm text-gray-700">
              <CheckCircle2 size={15} className="text-indigo-500 shrink-0 mt-0.5" />
              <span>
                {f.label}
                {f.note && <span className="text-gray-400 text-xs ml-1">({f.note})</span>}
              </span>
            </li>
          ))}
        </ul>

        <div className="flex gap-2">
          <Button className="flex-1" onClick={handleUpgrade}>Upgrade to Pro</Button>
          <Button variant="ghost" onClick={onClose}>Maybe later</Button>
        </div>
      </div>
    </div>
  )
}
